module.exports = __webpack_public_path__ + "static/media/5.35b9c73e.jpg";